<template>
	<nk-page :commercialAccess="['Sale', 'Warehouse']" :policyClaims="['Product_ProductGroup_Management']">
		<template #badges>
			<nk-badge system="sale"></nk-badge>
		</template>

		<div class="group-list h-100">
			<div class="row no-gutters h-100">
				<div class="group-list col-12 col-md-12 h-100 pl-1">
					<div class="card nk-card p-0 h-100">
						<div class="card-header">
							{{ $t('sale.product-group-list.information') }}
						</div>
						<div class="card-body h-100">
							<ag-tree ref="treeview" :data="filteredItems" :options="treeOptions" :model-value="selectedProductGroup" @selected="setSelectedProductGroup" @row-db-clicked="nodeDbClicked" :tabindex="201" startup></ag-tree>

							<!--							<nk-tree ref="treeview" :options="componentOptions.productGroupTree" :data="filteredItems" :selected="selectedProductGroup" @setSelected="setSelectedProductGroup" :tabindex="201" startup>-->
							<!--							</nk-tree>-->
						</div>
					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { post } from '~/plugins/nikan-api'
	import ProductGroupModify from './product-group-modify'
	import $sc from '~/plugins/shortcut.collection.js'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import { mapActions, mapState } from 'vuex'
	import { isEmpty } from '~/statics/validators'
	import emptyId from '~/statics/empty-id'
	import Endpoints from '@nikan/endpoints'
	import AgTree from '@/components/tree/ag-tree.vue'
	import AgTreeButtons from '@/components/tree/ag-tree-buttons.vue'

	export default {
		components: { AgTree },
		modal: {
			size: 'md',
			stateUID: 'product-group-list',
			helpTag: 'ProductGroupList'
		},
		props: {
			options: { type: Object },
			data: { type: Object },
		},
		data() {
			return {
				treeOptions: {
					parentIdentifier: (data) => data.treeHasChild && data.id,
					searchPlaceholder: this.$t('sale.product-group-list.search-placeholder'),
					searchableFields: ['level', 'code'],
					enableSearch: true,

					agOptions: {
						sideBar: 'none',
						rowSelection: {
							mode: 'singleRow'
						},
						excelExportParams: {
							allColumns: true,
						},
						csvExportParams: {
							allColumns: true,
						},
						treeData: true,
						rowHeight: 32,
						// fitToWidth:false,
						autoGroupColumnDef: {
							headerName: this.$t('document.f.centers'),
							contentType: 'enum',
							valueFormatter: (params) => {
								return params.data?.name && (`${params.data?.name} (${this.$t('code')} : ${params.data?.code})`)
							},
							minWidth: 300,
							width: 300,
							floatingFilter: false,
							cellRendererParams: {
								suppressCount: true,
							},
						},
						columnDefs: [
							{
								field: 'fullCode',
								headerName: this.$t('sale.product-group.f.fullCode'),
								hide: true,
								suppressColumnsToolPanel: true,
								floatingFilter: false,
							},
							{
								field: 'treeHasChild',
								headerName: this.$t('sale.product-group.f.isLastLevel'),
								valueGetter: (params) => !Boolean(params?.data?.treeHasChild),
								hide: true,
								suppressColumnsToolPanel: true,
								floatingFilter: false,
							},
							{
								field: 'buttons',
								headerName: this.$t('fiscal.f.fiscal-operation'),
								// contentType: 'enum',
								floatingFilter: false,
								// type: 'leftAligned',
								minWidth: 150,
								// maxWidth: 200,
								width: 100,
								suppressSizeToFit: true,
								cellRenderer: AgTreeButtons,
								cellRendererParams: (params) => {
									return {
										options: {
											editable: true,
											onNodeAddClicked: this.addChildProductGroup,
											onNodeEditClicked: this.editProductGroup,
											onNodeDeleteClicked: this.deleteProductGroup,
											editPolicyClaimsState: this.$nikan.checkPermission('Product_ProductGroup_Edit'),
											deletePolicyClaimsState: this.$nikan.checkPermission('Product_ProductGroup_Delete'),
										},
										data: params?.data
									}
								}
							},

						],
					}

				},
				selectedProductGroup: null,
				treeNodes: [],
				componentOptions: {
					productGroupTree: {
						enableSearch: true,
						editable: true,
						searchResultText: this.$t('msg.number-of-items-found'),
						onNodeAddClicked: this.addChildProductGroup,
						onNodeEditClicked: this.editProductGroup,
						onNodeDeleteClicked: this.deleteProductGroup,
						deletePolicyClaims: 'Product_ProductGroup_Delete',
						editPolicyClaims: 'Product_ProductGroup_Edit',
						searchPlaceholder: this.$t(
							'sale.product-group-list.search-placeholder'
						),
						defaultSortByFields: ['level', 'code'],
						display: (item) => {
							return (item.name.toLocaleDigits() + ' (&#x200E;' + item.code + ')')
						},
					},
				},
				productGroupInfo: {
					nodeData: null,
					parentData: null,
					state: '',
				},
				addProductGroupButton: {
					title: this.$t('sale.product-group.insert'),
					shortcut: $sc.find('new'),
					isPrimary: false,
					icon: 'plus',
					handle: (button, page, e) => {
						this.addRootProductGroup()
					},
					policyClaims: 'Product_ProductGroup_Add',
				},
				selectProductGroupButton: {
					title: this.$t('select'),
					shortcut: $sc.find('enter-only'),
					element: () => this.$refs.treeview.$el,
					icon: 'check',
					isPrimary: true,
					visible: (this.options || {}).selectable,
					handle: (button, page, e) => {
						this.resolve(this.selectedProductGroup)
					}
				},
				maxChildCode: null
			}
		},
		computed: {
			...mapState('productGroups', {
				all: (status) => status.items
			}),
			filteredItems() {
				return (this.treeNodes || []).sort((a, b) => {
					let res = a.level - b.level
					if (res === 0) {
						return a.id - b.id
					} else {
						return res
					}
				})
			},
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				},
			},
			all: {
				immediate: true,
				deep: true,
				handler(val) {

					// let nodes = this.all.filter((x) => x.parent == null || isEmpty(x.parent.id))

					this.maxChildCode = val
						.map((x) => Number(x.code))
						.reduce((max, current) => (max < current ? current : max), 0)
					this.treeNodes = _.cloneDeep(val)



				},
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)

			this.getProductGroupData()

			let buttonsArray
			if (this.grandParentType() === 'modal') {
				buttonsArray = [this.selectProductGroupButton, this.addProductGroupButton]
			} else {
				this.selectProductGroupButton.visible = false
				buttonsArray = [this.addProductGroupButton]
			}

			this.prepareWindow(this.$t('sale.product-group-list.title'), buttonsArray)
		},
		methods: {
			...mapActions({
				refresh_productGroups: 'productGroups/refresh',
				broadcastRefresh: 'socket/broadcastRefresh'
			}),
			nodeDbClicked(data) {
				this.resolve(data)
			},
			fillNodes(node) {
				let index = this.treeNodes.findIndex((x) => x.id === node.id)
				if (index === -1) {
					this.treeNodes = [...this.treeNodes, node]
				} else {
					this.treeNodes.splice(index, 1, node)
				}

				let parent = node.parent == null ? null : _.head(this.treeNodes.filter((x) => x.id === node.parent.id))

				if (parent != null && !parent.hasChild) {
					parent.hasChild = true
				}
			},
			async getProductGroupData(force = false) {
				var wait = this.$wait(this.$refs.treeview.$el)
				await this.refresh_productGroups({ force: force })
				wait.end()
				this.treeNodes = _.cloneDeep(this.all)
				this.selectedProductGroup = _.head(this.filteredItems)
			},
			setSelectedProductGroup(productGroup) {
				this.selectedProductGroup = productGroup
			},
			addRootProductGroup() {
				var productData = {
					id: emptyId,
					parent: null,
					code: this.maxChildCode + 1,
					name: '',
					hasChild: false,
					isEnabled: true,
					description: '',
					level: 1,
					accountingCode: '',
					position: null,
					group: null,
					centerCategory: null,
				}

				this.addTreeNode(productData, null)
			},
			addChildProductGroup(parent) {
				var productData = {
					id: emptyId,
					parent,
					code: this.maxChildCode + 1,
					name: '',
					hasChild: false,
					isEnabled: true,
					description: '',
					level: Number(parent.level) + 1,
					accountingCode: '',
					position: parent.position,
					group: parent.group,
					centerCategory: null,
				}

				this.addTreeNode(productData, parent)
			},
			addTreeNode(newNode, parent) {
				this.productGroupInfo.nodeData = typeof newNode === 'undefined' ? null : newNode
				this.productGroupInfo.parentData = parent
				this.productGroupInfo.parentScope = this
				this.productGroupInfo.state = parent ? 'add-child' : 'add-root'
				this.productGroupInfo.nodeData.nextChildCode = this.maxChildCode + 1
				this.showModal({
					component: ProductGroupModify,
					data: this.productGroupInfo,
				})
					.then((node) => {
						this.broadcastRefresh('ProductGroups')
						this.selectedProductGroup = node
						this.fillNodes(node)
						this.$refs.treeview.$el.focus()
					})
					.catch(() => {
						this.$refs.treeview.$el.focus()
					})
			},
			editProductGroup(node) {
				var nodeData = $.extend(true, {}, node)
				var parentData = this.getParentNodeById(
					nodeData.parent ? nodeData.parent.id : null
				)

				this.productGroupInfo.nodeData = typeof nodeData === 'undefined' ? null : nodeData
				this.productGroupInfo.parentData = typeof parentData === 'undefined' ? null : parentData
				this.productGroupInfo.state = 'edit'

				this.showModal({
					component: ProductGroupModify,
					data: this.productGroupInfo,
				})
					.then((result) => {
						this.productGroupInfo.nodeData = result
						this.broadcastRefresh('ProductGroups')
						$.each(this.treeNodes, (i, node) => {
							if (node.id === this.productGroupInfo.nodeData.id) {
								this.treeNodes.splice(i, 1, $.extend(true, {}, this.productGroupInfo.nodeData))
								// this.treeNodes[i].isSelected = true
								this.$refs.treeview.$el.focus()

								this.selectedProductGroup = this.treeNodes[i]
								return false
							}
						})
					})
					.catch(() => {
						this.$refs.treeview.$el.focus()
					})
			},
			deleteProductGroup(node) {
				dialog({
					title: this.$t('sale.product-group.want-to-delete'),
					body: this.$t('sale.product-group.warning-to-delete', {
						name: node.name,
					}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteProductGroupConfirmed(node)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteProductGroupConfirmed(node) {
				if (node.hasChild === true) {
					dialog({
						title: this.$t('sale.product-group.delete'),
						body: this.$t('msg.NotDeleted_ChildFound'),
						autoClose: true,
						type: 'error',
					})
				} else {
					post(Endpoints.getUrl('sale.product.group.delete'), {
						id: node.id,
					}).then((result) => {
						this.broadcastRefresh('ProductGroups')
						this.selectedProductGroup = null

						let index = this.treeNodes.findIndex((x) => x.id === node.id)
						if (index > -1) {
							this.treeNodes.splice(index, 1)

							if (node.parent) {
								let parent = _.head(
									this.treeNodes.filter((x) => x.id === node.parent.id)
								)
								let siblings = this.treeNodes.filter(
									(x) => x.parent && x.parent.id === parent.id
								)

								if (siblings.length > 0) {
									this.selectedProductGroup = siblings[siblings.length - 1]
								} else {
									parent.hasChild = false
									this.selectedProductGroup = parent
								}
							} else {
								this.selectedProductGroup = this.treeNodes[0]
							}
						}
						this.$refs.treeview.$el.focus()
						this.$toast(this.$t('sale.product-group.delete-success', {
							name: node.name,
						}), { type: 'success' })
					})
				}
			},
			getParentNodeById(id) {
				var parent = this.treeNodes.filter((x) => x.id === id)
				if (!this.$nikan.isZeroLength(parent)) {
					return parent[0]
				} else {
					return null
				}
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'product-group-search',
					shortcut: $sc.find('search'),
					el: this.$el,
					context: this,
					handler: (sender, e) => {
						var searchInput = $(this.$refs.treeview.$el).find('.filter-input')
						if (!this.$nikan.isZeroLength(searchInput)) {
							e.preventDefault()
							$(searchInput[0]).focus()
							return true
						}
					},
				})
			},
		},
	}
</script>
<style>
	.group-list .card-body {
		overflow: hidden;
	}
</style>
